import { defineComponent as _defineComponent } from 'vue'
import OzContainedButton, { OzContainedButtonColorScheme } from '@@/library/v4/components/OzContainedButton.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'AuthLoginSAMLButton',
  props: {
    text: { default: '' },
    logo: { default: '' }
  },
  emits: ['click'],
  setup(__props: any) {





return { __sfc: true,OzContainedButton, OzContainedButtonColorScheme }
}

})